(function () {
    // The section script can run again in the editor. Keep one lifecycle owner.
    if (window.whooAnnouncements) {
        window.whooAnnouncements.init(document);
        return;
    }

    const instances = new Map();
    const destroy = (section) => {
        const cleanup = instances.get(section);
        if (cleanup) cleanup();
        instances.delete(section);
    };
    const init = (root) => {
        for (const section of instances.keys()) {
            if (!section.isConnected) destroy(section);
        }
        const sections = root.matches?.('.section-announcement')
            ? [root] : root.querySelectorAll('.section-announcement');
        sections.forEach((section) => {
            if (instances.has(section)) return;
            const wrap = section.querySelector('.c-announce__swiper');
            if (!wrap) return;
            const multiple = wrap.querySelectorAll('.swiper-slide').length > 1;
            const previous = section.querySelector('.c-announce__left');
            const next = section.querySelector('.c-announce__right');
            [previous, next].forEach((button) => { if (button) button.hidden = !multiple; });
            section.classList.toggle('section-announcement--single', !multiple);
            if (!multiple || typeof Swiper === 'undefined') return;
            const swiper = new Swiper(wrap, {
                slidesPerView: 1,
                navigation: { prevEl: previous, nextEl: next },
                autoplay: { delay: 3000 },
                loop: true,
            });
            const stop = () => swiper.autoplay.stop();
            const start = () => {
                if (!wrap.matches(':hover') && !wrap.contains(document.activeElement)) swiper.autoplay.start();
            };
            wrap.addEventListener('mouseenter', stop);
            wrap.addEventListener('mouseleave', start);
            wrap.addEventListener('focusin', stop);
            wrap.addEventListener('focusout', start);
            instances.set(section, () => {
                wrap.removeEventListener('mouseenter', stop);
                wrap.removeEventListener('mouseleave', start);
                wrap.removeEventListener('focusin', stop);
                wrap.removeEventListener('focusout', start);
                swiper.destroy(true, true);
            });
        });
    };
    window.whooAnnouncements = { init };
    document.addEventListener('shopify:section:load', (event) => {
        destroy(event.target);
        init(event.target);
    });
    document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
    init(document);
})();
